const it = {
  placeholderText: "Inserisci",
  closeContentText: "Chiudere la conversazione corrente?",
  cancelText: "Annulla",
  okText: "OK",
  loadingAnswerQuestions:
    "Rispondendo alla domanda precedente. Attenda prima di inviare.",
  networkAnomalyText: "Anomalia di rete. Riprova più tardi.",
  errorText: "Errore del server",
  messageTooShort: "È necessario inserire almeno due caratteri.",
  messageTooLong: "Non può superare 200 caratteri.",
  systemErrorText: "​Errore di sistema. Riprova più tardi.​​​​​",
  fileSizeExceeded: "Un singolo file non può superare {maxSize}MB.",
  abnormalDisconnectionText: "Connessione persa. Riconnessione in corso...",
  evaluationText: "Il vostro feedback ci aiuta a migliorare!",
  emailLabel: "Indirizzo Email​",
  emailPlaceholder: "Inserisci il tuo indirizzo email",
  emailErrorText: "Formato email non valido.",
  productLabel: "Prodotto",
  productPlaceholder: "Seleziona un prodotto",
  problemLabel: "Descrizione problema",
  problemPlaceholder: "Descrivi il problema nei dettagli",
  submitText: "Invia",
  submitField: "Invio fallito. Ti preghiamo di riprovare più tardi.",
  thankText:
    "Grazie per la tua collaborazione! Ti contatteremo al più presto! Controlla la tua email o {link}​ per seguire le risposte!",
  clickHere: "fai clic qui​",
  thankEvaluation: "Grazie per la valutazione!",
  codeLabel: "Codice di verifica",
  codePlaceholder: "Inserisci il codice di verifica",
  submittedSuccessfully: "Invio riuscito",
  supportContact: "Contatto di supporto",
  stillCancel: "Annulla comunque",
  useDiscount: "Usa lo sconto",
  pauseDuration: "Durata della pausa",
  uploadAttachment: "Carica allegato",
};
export default it;
